import MenuFoldOutlined from '@ant-design/icons/MenuFoldOutlined';
import MenuUnfoldOutlined from '@ant-design/icons/MenuUnfoldOutlined';
import { memo, type MouseEvent, useCallback } from 'react';

type SidebarCollapseToggleProps = {
  isCollapsed: boolean;
  onChange?: (next: boolean) => void;
};

export const SidebarCollapseToggle = memo(
  ({ isCollapsed, onChange }: SidebarCollapseToggleProps) => {
    const handleToggle = useCallback(
      (event: MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        onChange?.(!isCollapsed);
      },
      [isCollapsed, onChange]
    );

    return (
      <div className="w-full px-0">
        <button
          type="button"
          className="flex w-full cursor-pointer items-center justify-start gap-2 rounded-lg border border-white/15 bg-white/[0.08] px-3 py-2 text-xs font-medium text-white/75 transition hover:bg-white/15 hover:text-white"
          onClick={handleToggle}
          title={isCollapsed ? 'Mở rộng sidebar' : 'Thu gọn sidebar'}
        >
          {isCollapsed ? (
            <MenuUnfoldOutlined className="text-base text-white/90" />
          ) : (
            <MenuFoldOutlined className="text-base text-white/90" />
          )}
          <span className="truncate">
            {isCollapsed ? 'Mở rộng' : 'Thu gọn'} sidebar
          </span>
        </button>
      </div>
    );
  }
);
